import { useQuery } from "@tanstack/react-query";

import { api } from "./ApiClient";

import { AuthHelper } from "../helpers/auth.helper";

import { EtyCohort } from "../types/entities.interface";

export const useGetCohorts = (enabled: boolean) => {
    AuthHelper.presetPrivateRequest(api);

    const queryFn = async (): Promise<EtyCohort[]> => {
        const res = await api.get('/cohorts/list');
        return res.data;
    };

    return useQuery({
        queryKey: ['cohorts'],
        enabled,
        queryFn,
    });
};